/**
 * MediaTrackType enum.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * @enum {string}
 */
const MediaTrackType = {
    VIDEO: 'video',
    AUDIO: 'audio',
};


export default MediaTrackType;
